export default "__VITE_ASSET__CwK24TX6__"